/*
* @Author: lee
* @Date:   2018-01-14 17:38:22
* @Last Modified by:   lee
* @Last Modified time: 2018-01-14 18:18:46
*/
export function addClass(el, className) {

  if (hasClass(el, className)) return;
  let newClass = el.className.split(' ');
  newClass.push(className);

  el.className = newClass.join(' ');

}
export function hasClass(el, className) {
  let reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
  return reg.test(el.className)
}

//移除class
export function removeClass(el, className){
  if(!hasClass(el, className)) return
  let newClass = el.className.split(' ').filter(item => item !== className)
  el.className = newClass.join('')
}

/* css属性prefix */
let elementStyle = document.createElement("div").style
let vendor = (() => {
  let transformNames = {
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform',
    standard: 'transform'
  }
  for (let key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      //console.log("key",key)
      return key
    }
  }
  return false
})()


export function prefixStyle(style) {
  if (vendor === false)
    return false
  if (vendor === 'standard')
    return style
  return vendor + style.charAt(0).toUpperCase() + style.substr(1)
}

export function getWindowScrollTop(){
  return document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
}



// WEBPACK FOOTER //
// ./src/apps/zcx/common/dom.js